import {observer} from 'mobx-react-lite'
import React, {useState} from 'react'
import {Lang} from 'yougile-lang'
import {logger} from 'yougile-util'
import {ErrorBoundary} from '@components/common/error-boundary/error-boundary'
import {cn} from '@containers/html-utils'
import {globals} from '@extensions/globals-base'
import type {Company} from '../company-login/types'
import {LoginNotAcceptedDialog} from './login-not-accepted-dialog'
import {LoginContext, LoginStore, useLoginStore} from './login-store'
import {LoginWindow} from './login-window'

type Props = {company?: Company}

export const Login = (props: Props) => {
  const [loginStore] = useState(() => new LoginStore(props))

  return (
    <ErrorBoundary
      silent
      onError={e => logger.error('recovery error ' + e.message)}
    >
      <LoginContext.Provider value={loginStore}>
        <LoginBase />
      </LoginContext.Provider>
    </ErrorBoundary>
  )
}

const LoginBase = observer(() => {
  const [state] = useLoginStore()

  return (
    <div className="text-center login-main">
      <div
        className={cn(
          'login overflow-y-auto',
          state.isDesktop && 'desktop',
          state.forgetShow && 'forget',
          state.serverShow && 'server'
        )}
      >
        {globals.standalone && (
          <a
            className="login-logo"
            href="https://yougile.com"
            target="_blank"
            rel="noopener"
          />
        )}

        <LoginNotAcceptedDialog />
        <LoginWindow />
      </div>
      {!state.isDesktop && (
        <div className="login-footer">
          <div className="login-footer-cnt">
            <span>{state.copy}</span>
            {!globals.standalone && (
              <span className="login-footer-fb _link redhlp_button redhlp_button_bottom">
                {Lang.msg.justFeedback}
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  )
})
